import {Store} from '../classes/store';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';
import {Area} from '../../../resources/area/area.interface';

@Injectable({
  providedIn: 'root'
})
export class AreaStore extends Store<Area> {

  /** Constructor. */
  constructor( ) {
    super();
  }

}
